<template>
  <div class="wrapper">
    <div class="top_navbar">
      <div class="hamburger">
        <div class="hamburger__inner">
          <div class="one"></div>
          <div class="two"></div>
          <div class="three"></div>
        </div>
      </div>
      <div class="menu">
        <div class="logo">Barber Shop</div>
        <div class="right_menu">
          <button @click="logout" class="btn btn-danger">Logout</button>
        </div>
      </div>
    </div>

    <div class="main_container">
      <div class="sidebar">
        <div class="sidebar__inner">
          <div class="profile">
            <div class="img">
              <img src="@/assets/images/Frame.png" alt="profile_pic" />
            </div>
            <div class="profile_info">
              <p>Welcome</p>
              <p class="profile_name">Kingz Barber</p>
            </div>
          </div>
          <ul class="nav-tabs-admin">
            <li>
              <router-link to="/admin" class="text-decoration-none ps-4">
                <span class="icon"><i class="fa fa-tachometer"></i></span>
                <span class="title">Dashboard</span>
              </router-link>
            </li>
            <li v-if="can('list-service') || can('add-service')">
              <a
                class="nav-link text-white"
                href="#submenu1"
                data-bs-toggle="collapse"
                data-target="#submenu1"
              >
                <span class="icon"><i class="fa fa-wrench"></i></span>
                <span class="title">SERVICE</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu1"
                aria-expanded="false"
                v-if="can('list-service') || can('add-service')"
              >
                <li class="nav-item sub-item" v-if="can('add-service')">
                  <router-link to="/admin/service/create" class="ps-4">
                    <a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">ADD</span>
                    </a></router-link
                  >
                </li>
                <li class="nav-item sub-item" v-if="can('list-service')">
                  <router-link to="/admin/service" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">LIST</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>

            <li v-if="can('list-user') || can('add-user')">
              <a
                class="nav-link text-white"
                href="#submenu2"
                data-bs-toggle="collapse"
                data-target="#submenu2"
              >
                <span class="icon"><i class="fa fa-user"></i></span>
                <span class="title">STAFFS</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu2"
                aria-expanded="false"
                v-if="can('list-user') || can('add-user')"
              >
                <li class="nav-item sub-item" v-if="can('add-user')">
                  <router-link to="/admin/user/create" class="ps-4">
                    <a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">ADD</span>
                    </a></router-link
                  >
                </li>
                <li class="nav-item sub-item" v-if="can('list-user')">
                  <router-link to="/admin/user" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">LIST</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="can('list-role') || can('add-role')">
              <a
                class="nav-link text-white"
                href="#submenu3"
                data-bs-toggle="collapse"
                data-target="#submenu3"
              >
                <span class="icon"><i class="fa fa-users"></i></span>
                <span class="title">Roles</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu3"
                aria-expanded="false"
                v-if="can('list-role') || can('add-role')"
              >
                <li class="nav-item sub-item" v-if="can('add-role')">
                  <router-link to="/admin/role/create" class="ps-4">
                    <a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">ADD</span>
                    </a></router-link
                  >
                </li>
                <li class="nav-item sub-item" v-if="can('list-role')">
                  <router-link to="/admin/role" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">LIST</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="can('list-daily-token')">
              <a href="#">
                <span class="icon"><i class="fa fa-delicious"></i></span>
                <span class="title">Token</span>
              </a>
            </li>
            <li
              v-if="
                can('list-registered-device') || can('add-registered-device')
              "
            >
              <a
                class="nav-link text-white"
                href="#submenu4"
                data-bs-toggle="collapse"
                data-target="#submenu4"
              >
                <span class="icon"><i class="fa fa-mobile"></i></span>
                <span class="title">Device</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu4"
                aria-expanded="false"
                v-if="
                  can('list-registered-device') || can('add-registered-device')
                "
              >
                <li
                  class="nav-item sub-item"
                  v-if="can('add-registered-device')"
                >
                  <router-link to="/admin/device/create" class="ps-4">
                    <a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">ADD</span>
                    </a></router-link
                  >
                </li>
                <li
                  class="nav-item sub-item"
                  v-if="can('list-registered-device')"
                >
                  <router-link to="/admin/device" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">LIST</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="can('list-setting')">
              <a
                class="nav-link text-white"
                href="#submenu5"
                data-bs-toggle="collapse"
                data-target="#submenu5"
              >
                <span class="icon"><i class="fa fa-cogs"></i></span>
                <span class="title">SETTING</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu5"
                aria-expanded="false"
              >
                <li class="nav-item sub-item">
                  <router-link to="/admin/setting" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">LIST</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="can('list-token-by-criteria')">
              <a
                class="nav-link text-white"
                href="#submenu6"
                data-bs-toggle="collapse"
                data-target="#submenu6"
              >
                <span class="icon"><i class="fa fa-bar-chart"></i></span>
                <span class="title">REPORT</span>
                <span class="icon ms-auto me-0"
                  ><i class="fa fa-angle-down"></i
                ></span>
              </a>
              <ul
                class="list-unstyled flex-column collapse"
                id="submenu6"
                aria-expanded="false"
              >
                <li class="nav-item sub-item">
                  <router-link :to="{ name: 'ReportByDate' }" class="ps-4"
                    ><a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">BY DATE</span>
                    </a></router-link
                  >
                </li>
                <li class="nav-item sub-item">
                  <router-link :to="{ name: 'ReportByDateRange' }" class="ps-4">
                    <a class="nav-link text-white p-0" href="">
                      <span class="icon"><i class="fa fa-circle"></i></span>
                      <span class="title">DATE RANGE</span>
                    </a></router-link
                  >
                </li>
              </ul>
            </li>
            <li style="background-color: #333333">
              <router-link :to="{ name: 'DailyTokenTVScreen' }">
                <a href="javascript:void" class="text-decoration-none ps-2">
                  <span class="icon"
                    ><i class="fa fa-television text-white"></i
                  ></span>
                  <span class="title text-white">TV Screen</span>
                </a>
              </router-link>
            </li>
            <li style="background-color: green">
              <router-link :to="{ name: 'SubscriptionList' }">
                <a href="javascript:void" class="text-decoration-none ps-2">
                  <span class="icon"
                    ><i class="fa fa-dollar text-white"></i
                  ></span>
                  <span class="title text-white">Subscription</span>
                </a>
              </router-link>
            </li>
            <li
              style="background-color: #aa1415"
              v-if="can('truncate-daily-token')"
            >
              <a
                href="javascript:void"
                @click="truncateData()"
                class="text-decoration-none ps-2"
              >
                <span class="icon"><i class="fa fa-trash"></i></span>
                <span class="title">Truncate</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  mounted() {
    $(document).ready(function () {
      $(".hamburger .hamburger__inner").click(function () {
        $(".wrapper").toggleClass("active");
      });

      $(".top_navbar .fas").click(function () {
        $(".profile_dd").toggleClass("active");
      });
    });
  },
  methods: {
    logout() {
      this.$http.post("auth/logout").then((res) => {
        console.log(res);
        sessionStorage.removeItem("token");
        this.$router.push("/admin/login");
      });
    },
    truncateData() {
      this.$http.post("token/daily-trucate").then((res) => {
        console.log(res);
        this.$notify({
          group: "notifications",
          title: "User",
          type: "success",
          text: "Data Truncated Successfullt",
        });
      });
    },
  },
};
</script>

<style scoped></style>
